import { retrieve } from '@shared';
import { JobFeaturedCandidate } from '@shared/models/job-featured-candidate';
import { candidatesJobsList } from '../candidates.actions';

export const CandidatesBestJobsKey = 'candidatesBestJobs';
export interface CandidatesBestJobs {
  content: JobFeaturedCandidate[];
}

export const bestJobsInitialState: CandidatesBestJobs = {
  content: [],
};

export function candidatesBestJobsReducer(
  state = retrieve(CandidatesBestJobsKey, bestJobsInitialState),
  action: { type: string; payload: JobFeaturedCandidate[] },
): CandidatesBestJobs {
  if (action.type === candidatesJobsList.type) {
    return {
      content: [...action.payload],
    };
  } else {
    return state;
  }
}
